define('bindingHandlers/numberRangePicker',[
    'lib/knockout',
    'lib/lodash4',
    'enums/bindingHandlers/rangePickerModes',
    'bindingHandlers/include'
], function (
    ko,
    _,
    RANGE_PICKER_MODES
    ) {
    "use strict";

    ko.bindingHandlers.numberRangePicker = {
        init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
            var self = this;

            var number_range_template = 'templates/widgets/numberRangePicker';
            var templateData = [];

            var bindingData = valueAccessor();

            templateData.low = bindingData.low;
            templateData.high = bindingData.high;
            templateData.mode = ko.observable(RANGE_PICKER_MODES.BETWEEN);
            templateData.RANGE_PICKER_MODES = RANGE_PICKER_MODES;

            if (bindingData.template && typeof(bindingData.template) === 'string') {
                number_range_template = bindingData.template;
            }

            /*
             * Verify that the low and high numbers are actually numbers
             */
            var low = templateData.low();
            if (!_.isInteger(low)) {
                templateData.low(0);
            }

            var high = templateData.high();
            if (!_.isInteger(high)) {
                templateData.high(0);
            }

            // infer the mode from the initial low and high values
            if (templateData.low() === 0 && templateData.high() > 0) {
                templateData.mode(RANGE_PICKER_MODES.UNDER);
            }
            else if (templateData.low() > 0) {
                templateData.mode(RANGE_PICKER_MODES.OVER);
            }

            // pick reasonable settings when the mode is changed
            templateData.mode.subscribe(function(newValue) {
                if (newValue == RANGE_PICKER_MODES.BETWEEN) {
                    templateData.low(0);
                    templateData.high(0);
                }

                if (newValue == RANGE_PICKER_MODES.UNDER) {
                    templateData.low(0);
                    templateData.high(0);
                }

                if (newValue == RANGE_PICKER_MODES.OVER) {
                    templateData.low(0);
                    templateData.high(100);
                }
            });

            var includeValueAccessor = ko.observable({
                name: number_range_template,
                data: templateData
            });

            ko.bindingHandlers.include.init.call (self, element, includeValueAccessor, allBindings, viewModel, bindingContext);
            ko.bindingHandlers.include.update.call(self, element, includeValueAccessor, allBindings, viewModel, bindingContext);
        }
    };
});

